import React from 'react';
import { PlayIcon, HeartIcon, MessageSquareIcon, ShareIcon } from 'lucide-react';
interface VideoStory {
  id: string;
  thumbnail: string;
  title: string;
  likes: number;
  comments: number;
  shares: number;
  duration: string;
}
export const CommunityStories = () => {
  const stories: VideoStory[] = [{
    id: '1',
    thumbnail: 'https://images.pexels.com/photos/3760323/pexels-photo-3760323.jpeg',
    title: 'What phone are you using?',
    likes: 229200,
    comments: 781,
    shares: 419,
    duration: '00:35'
  }, {
    id: '2',
    thumbnail: 'https://images.pexels.com/photos/4195326/pexels-photo-4195326.jpeg',
    title: 'iPhone 14 Pro Max review',
    likes: 26,
    comments: 1,
    shares: 3,
    duration: '00:20'
  }, {
    id: '3',
    thumbnail: 'https://images.pexels.com/photos/6802048/pexels-photo-6802048.jpeg',
    title: 'Unboxing the Galaxy S23',
    likes: 140,
    comments: 2,
    shares: 0,
    duration: '00:21'
  }, {
    id: '4',
    thumbnail: 'https://images.pexels.com/photos/7610442/pexels-photo-7610442.jpeg',
    title: 'Old way vs New way',
    likes: 13,
    comments: 0,
    shares: 0,
    duration: '00:08'
  }];
  const formatNumber = (num: number): string => {
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  };
  return <section className="py-12" data-id="element-931">
      <div className="container mx-auto px-4" data-id="element-932">
        <div className="flex justify-between items-center mb-6" data-id="element-933">
          <h2 className="text-3xl font-bold text-gray-800" data-id="element-934">
            Community stories
          </h2>
          <span className="text-gray-500" data-id="element-935">See what others are saying</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-936">
          {stories.map(story => <div key={story.id} className="bg-gray-100 rounded-lg overflow-hidden relative group" data-id="element-937">
              <img src={story.thumbnail} alt={story.title} className="w-full h-80 object-cover" data-id="element-938" />
              <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center" data-id="element-939">
                <button className="bg-white bg-opacity-80 rounded-full p-3 hover:bg-opacity-100 transition-all" data-id="element-940">
                  <PlayIcon className="h-8 w-8 text-black" data-id="element-941" />
                </button>
              </div>
              <div className="absolute top-4 left-4 right-4 flex justify-between" data-id="element-942">
                <div className="flex items-center" data-id="element-943">
                  <div className="h-8 w-8 rounded-full bg-white flex items-center justify-center" data-id="element-944">
                    <img src="https://placehold.co/30x30/blue/white?text=SU" alt="SellUp logo" className="h-6 w-6 rounded-full" data-id="element-945" />
                  </div>
                  <div className="ml-2" data-id="element-946">
                    <div className="text-white text-sm font-bold" data-id="element-947">
                      SellUp Singapore
                    </div>
                    <div className="text-white text-xs opacity-80" data-id="element-948">
                      sellup_sg
                    </div>
                  </div>
                </div>
                <img src="https://upload.wikimedia.org/wikipedia/en/a/a9/TikTok_logo.svg" alt="TikTok" className="h-6" data-id="element-949" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4" data-id="element-950">
                <div className="text-white font-bold mb-2" data-id="element-951">{story.title}</div>
                <div className="flex items-center justify-between text-white" data-id="element-952">
                  <div className="flex items-center space-x-4" data-id="element-953">
                    <button className="flex flex-col items-center" data-id="element-954">
                      <PlayIcon className="h-5 w-5" data-id="element-955" />
                      <span className="text-xs" data-id="element-956">{story.duration}</span>
                    </button>
                  </div>
                  <div className="flex space-x-4" data-id="element-957">
                    <button className="flex flex-col items-center" data-id="element-958">
                      <HeartIcon className="h-5 w-5" data-id="element-959" />
                      <span className="text-xs" data-id="element-960">
                        {formatNumber(story.likes)}
                      </span>
                    </button>
                    <button className="flex flex-col items-center" data-id="element-961">
                      <MessageSquareIcon className="h-5 w-5" data-id="element-962" />
                      <span className="text-xs" data-id="element-963">
                        {formatNumber(story.comments)}
                      </span>
                    </button>
                    <button className="flex flex-col items-center" data-id="element-964">
                      <ShareIcon className="h-5 w-5" data-id="element-965" />
                      <span className="text-xs" data-id="element-966">
                        {formatNumber(story.shares)}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};